// extracted by mini-css-extract-plugin
export var facebook = "social-module--facebook--0c458";
export var instagram = "social-module--instagram--d48f2";
export var linkedin = "social-module--linkedin--10ce1";
export var small = "social-module--small--b683b";
export var social = "social-module--social--20790";
export var twitter = "social-module--twitter--03208";